// export 文を使って関数 greet1 を定義
export const headerScrollAction01 = () => {
  let lastScrollTop = 0; // 前回のスクロール位置
  let scrollTimeout;

  document.addEventListener("scroll", function () {
    let scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop) {
      // 下にスクロールしている場合
      document.body.classList.add("is-scroll");
    } else if (scrollTop <= 0) {
      // 上にスクロールしている場合
      document.body.classList.remove("is-scroll");
    } else {
      // 上にスクロールしている場合
      document.body.classList.remove("is-scroll");
    }

    // スクロール停止を検知するためにタイマーをリセット
    // clearTimeout(scrollTimeout);
    // scrollTimeout = setTimeout(function () {
    //   // スクロールが止まったと判断されるときにクラスを削除
    //   document.body.classList.remove("is-scroll");
    // }, 500);

    // 現在のスクロール位置を保存して次のスクロール時に比較
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // 負の値を避けるためにscrollTopが0以下の場合リセット
  });
};
